/** Prefix for applied-job IDs that are not Algolia objectIDs */
export const EXTERNAL_APPLIED_JOB_ID_PREFIX = 'ext_' as const;

export function isExternalAppliedJobId(jobId: string): boolean {
  return jobId.startsWith(EXTERNAL_APPLIED_JOB_ID_PREFIX) && jobId.length > EXTERNAL_APPLIED_JOB_ID_PREFIX.length + 4;
}

export function createExternalAppliedJobId(): string {
  const id =
    typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID()
      : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
  return `${EXTERNAL_APPLIED_JOB_ID_PREFIX}${id}`;
}
